import { AdapterFactory } from './adapter-factory';

export const DefaultAdapter = AdapterFactory({ convertEventToValue: event => event.target.value });

